'use client';

import { trackPageViewClient } from '@otter-ai/telemetry/dist';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { trackAppInit } from '#utils';

export function PageViewTrackingProvider() {
  const pathname = usePathname();
  const prevPathnameRef = useRef<string | null>(null);

  useEffect(() => {
    const currentPathname = pathname;
    const prevPathname = prevPathnameRef.current;

    const shouldLogWebPageView = currentPathname !== prevPathname;

    if (shouldLogWebPageView && typeof window !== 'undefined') {
      trackPageViewClient();
    }

    prevPathnameRef.current = currentPathname;
  }, [pathname]);

  const isAppTrackedRef = useRef(false);
  useEffect(() => {
    if (isAppTrackedRef.current) return;
    trackAppInit();
    isAppTrackedRef.current = true;
  }, []);

  return null;
}
